import {
    observable, computed, reaction, makeObservable,
} from 'mobx'
import Question from '../Question'
import PageQuestionAPI from '../API/PageQuestion'

const iPageQuestion = () => {
    const pageQuestion = {
        id: '00000000-0000-0000-0000-000000000000',
        pageQuestionId: 0,
        questionId: '00000000-0000-0000-0000-000000000000',
        parentId: '00000000-0000-0000-0000-000000000000',
        priority: 1,
        isMandatory: true,
        isLocked: false,
        deletable: true,
        hasPrepopulatedData: false,
        questionLevel: 'survey',
    }

    return pageQuestion
}

const questions = {}

class PageQuestion {
    id

    fetchFailed = false

    modifiable = true

    visible = true

    @observable status = 'initial'

    @observable isMandatory

    @observable isLocked

    @observable parentId

    @observable inheritVisible = false

    @observable deletable

    @observable titles = {}

    @computed get questionType() {
        if (!questions[this.id]) return ''
        console.log(`questionTitle ${questions[this.id].question_type.value}`)
        return questions[this.id].question_type.value
    }

    @computed get questionTitle() {
        const locale = this.survey.lang.value

        if (!questions[this.id]) return ''

        return questions[this.id].langs.get(locale).T.text
    }

    @computed get inheritQuestion() {
        return { value: '' }
    }

    @computed get hasSkipLogic() {
        return this.findSkipLogic()
    }

    @computed get hasSkipToPageLogic() {
        return this.survey.skipLogic.find((sl) => (
            sl.action.kind === 'SkipToPage' && !sl.trigger && sl.triggerGroups[0].children[0].triggers[0].condition.pageQuestionId === this.id
        ))
    }

    @computed get isEditable() {
        if (!questions[this.id]) return false

        return questions[this.id].isEditable
    }

    constructor(pageQuestion, store, survey) {
        makeObservable(this)
        this.store = store
        this.survey = survey

        Object.assign(this, iPageQuestion())
        Object.assign(this, pageQuestion)

        survey.pageQuestions[this.id] = this

        this.currentOptions = this.getCurrentOptions()
        questions[this.id] = new Question(question, store, survey, true)
        reaction(
            () => this.getCurrentOptions(),
            (currentOptions) => this.update(currentOptions),
        )
    }

    populate(question, cb) {
        const questionId = question.question.id
        questions[this.id].populateFromData(question, this.survey, questionId, cb)
        this.setDeletable(question.questionId)
    }

    setDeletable(questionId) {
        const that = this
        const { survey } = this
        let url = `/qlist/mandatory/${questionId}`
        url += `?surveyType=${survey.surveytype.value}`
        url += `&respondentType=${survey.respondenttype.value}`
        url += `&productType=${survey.producttype}`
        that.store.http.get(url)
            .then((response) => {
                that.deletable = !response.mandatory
            })
            .catch((e) => {
                console.error(e)
            })
    }

    update(options) {
        const body = {}
        for (const optionKey in options) {
            if (options[optionKey] !== this.currentOptions[optionKey]) {
                body[optionKey] = options[optionKey]
            }
        }
        this.currentOptions = options
        PageQuestionAPI.update(this, body, this.store)
    }

    async updateQuestionMapping(body) {
        const { surveyToken } = this.store
        await this.store.http.put(`/api/survey/${this.survey.id}/pageQuestion/${this.id}/populateFrom`, body, surveyToken)
    }

    getCurrentOptions() {
        return {
            mandatory: this.isMandatory,
            isLocked: this.isLocked,
            parentId: this.parentId,
        }
    }

    isInheritable() {
        if (!questions[this.id]) return false
        return questions[this.id].isInheritable()
    }

    getQuestionLevel() {
        if (!questions[this.id]) return 'product'
        const question = questions[this.id]
        let level = 'product'
        if (question.clientId === 1) {
            level = 'explori'
        } else if (question.oid === 4) {
            level = 'division'
        } else if (question.oid < 6) {
            level = 'client'
        }

        return level
    }

    getQuestion() {
        if (!questions[this.id]) return null
        return questions[this.id]
    }

    findSkipLogic() {
        return this.survey.skipLogic.find((logic) => logic.action.pageQuestionId === this.id)
    }
}

export default PageQuestion
